<form [formGroup]="form">
    <div
        class="flex flex-col gap-6 bg-neutral-200 pt-3 pb-5 px-5 rounded-3xl items-center justify-center"
    >
        <div class="flex items-center justify-between w-full">
            <mat-icon class="!text-2xl !w-auto !h-auto !text-primary-700">
                insert_drive_file
            </mat-icon>
            @if (isDownloadable) {
                <a
                    role="link"
                    tabindex="0"
                    class="text-sm font-medium cursor-pointer text-primary-700 hover:text-primary-800 underline"
                    (click)="downloadAttachment()"
                    (keydown.enter)="downloadAttachment()"
                >
                    {{ truncatedFilename() }}
                </a>
            } @else {
                <span class="text-sm font-medium text-primary-700">
                    {{ truncatedFilename() }}
                </span>
            }
            <mat-icon
                class="!text-2xl !w-auto !h-auto !text-error-700 cursor-pointer"
                (click)="remove()"
            >
                close
            </mat-icon>
        </div>
        <div class="w-full">
            <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="w-full"
            >
                <mat-label>Attachment Type</mat-label>
                <mat-select formControlName="attachmentTypeCode">
                    @for (
                        attachmentTypeCode of attachmentTypeCodeOptions;
                        track attachmentTypeCode.value
                    ) {
                        <mat-option [value]="attachmentTypeCode.value">{{
                            attachmentTypeCode.label
                        }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="w-full">
            <mat-form-field
                appearance="outline"
                subscriptSizing="dynamic"
                class="w-full"
            >
                <mat-label>File Description (max 60 characters)</mat-label>
                <textarea
                    formControlName="description"
                    title="Notes"
                    matInput
                    maxlength="60"
                    rows="2"
                    class="!resize-none"
                    [appRegexInput]="
                        regExPattern.PrintableAsciiExceptAngleBracketsAndPipes
                    "
                ></textarea>
            </mat-form-field>
        </div>
    </div>
</form>
